import BaseHandler from "../BaseHandler";
import { UserAvatarAddResponse } from "../../proto/UserAvatarAdd_pb";
import store from "../../store";
import { updateUser } from "../../store/users/actions";
import { getStorage } from "../../libs/storage";
import { STORAGE_USER_ID } from "../../constants/localstorage";

export default class HandleUserAddAvatarResponse extends BaseHandler<UserAvatarAddResponse> {
  handle() {
    const userAvatarAddResponse = this.response.toObject();
    store.dispatch(
      updateUser({
        userId: getStorage(STORAGE_USER_ID),
        values: {
          avatar: userAvatarAddResponse.avatar,
        },
      })
    );
  }
}
